import { TID } from "@/lib/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={TID.footer}
      className="relative border-t border-[rgba(197,160,89,0.25)] overflow-hidden bg-[#0C0F0A]"
    >
      {/* Editorial backdrop — atmospheric, no figures */}
      <div aria-hidden className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_55%_at_50%_-10%,rgba(197,160,89,0.10),transparent_60%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_40%_at_50%_120%,rgba(48,72,55,0.45),transparent_70%)]" />
        <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-px bg-gradient-to-b from-transparent via-[rgba(197,160,89,0.12)] to-transparent" />
        <div
          className="absolute inset-0 opacity-[0.05] mix-blend-overlay"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix type='matrix' values='0 0 0 0 0.95 0 0 0 0 0.85 0 0 0 0 0.55 0 0 0 0.6 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
          }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-28 sm:pt-36 pb-16">
        {/* House statement — quiet, editorial */}
        <div className="text-center max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-4">
            <span className="block w-12 h-px bg-[#C5A059]" />
            <span className="text-[10px] uppercase tracking-[0.42em] text-[#C5A059]">
              The House
            </span>
            <span className="block w-12 h-px bg-[#C5A059]" />
          </div>

          <p className="mt-10 font-serif-display text-[#F5F2EB] text-2xl sm:text-3xl lg:text-[2.6rem] font-light leading-[1.18] tracking-tight">
            A private watch house. Limited production. Released only when each
            piece meets our standards.
          </p>
        </div>

        <div className="hairline mt-24" />

        {/* House identity + registry allocation note */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-start mt-16">
          <div>
            <div className="font-serif-display text-[#F5F2EB] text-3xl tracking-[0.18em]">
              CLEMENT
            </div>
            <p className="overline mt-3">Course I · By Registry</p>
          </div>
          <div className="md:col-span-2 space-y-6">
            <p className="font-serif-display text-[#F5F2EB] text-lg sm:text-xl leading-[1.55] max-w-xl font-light">
              CLEMENT produces limited-series mechanical timepieces for
              collectors, members and bespoke commissioning.
            </p>
            <p className="text-[#A8A9AD] text-sm leading-relaxed max-w-xl">
              Allocation, collection announcements and commissioning
              information are issued exclusively through The Private Registry.
            </p>
          </div>
        </div>

        <div className="hairline mt-20" />

        {/* Discreet legal strip */}
        <div className="mt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-[10px] uppercase tracking-[0.32em] text-[#A8A9AD]">
          <span>© {new Date().getFullYear()} CLEMENT</span>
          <span>Course I · Allocation by Registry</span>
        </div>
      </div>
    </footer>
  );
}
